export const accessibilityOptions = [
    'afterFirstUnlock',
    'afterFirstUnlockThisDeviceOnly',
    'whenUnlocked',
    'whenUnlockedThisDeviceOnly',
    'always',
    'alwaysThisDeviceOnly',
    'whenPasscodeSetThisDeviceOnly'
];
export var WebStorageAdapter;
(function (WebStorageAdapter) {
    WebStorageAdapter["LocalStorage"] = "LocalStorage";
    WebStorageAdapter["SessionStorage"] = "SessionStorage";
    WebStorageAdapter["SessionCookie"] = "SessionCookie";
})(WebStorageAdapter || (WebStorageAdapter = {}));
//# sourceMappingURL=definitions.js.map